export const TimelineEndpoint = (makeRequest) => {
    return {
        // Fetch prescription timeline status and the active status for the given prescription ID
        fetchByPrescription(params, options) {
            return makeRequest('GET', '/v3/prescriptions/timeline', params, options);
        },
    };
};
//# sourceMappingURL=timeline_endpoint.js.map